import { Component, DebugElement, ViewChild } from "@angular/core";
import { Parametro, PolizaService } from "./poliza.service";
import { IntermediariosService } from "./intermediarios/intermediarios.service";
import { OnInit } from "@angular/core";
import { BuscarPersonaPlantilla } from "../Modelos/BuscarPersonaPlantilla";
import { ProductoComponent } from "./producto/producto.component";
import { TextosComponent } from "./textos/textos.component";
import { IntermediariosComponent } from "./intermediarios/intermediarios.component";
import { Poliza } from "../Modelos/Poliza";
import { Intermediario } from "../Modelos/Intermediario";
import { PersonaNueva } from "../Modelos/PersonaNueva";
import { Participante, Persona } from "../Modelos/Persona";
import { Amparo } from "../Modelos/Amparo";
import { environment } from "src/environments/environment";
import { ActivatedRoute } from "@angular/router";
import * as printJS from "print-js";
import { PersonaGobernabilidad } from "../Modelos/PersonaGobernabilidad";
import { SeguridadService } from "../seguridad/seguridad.service";
import { AppComponent } from "../app.component";
import { Colaborador } from "../Modelos/Colaborador";
import { ParametrizacionEnlacesService } from "../parametrizacion-enlaces/parametrizacion-enlaces.service";
import { CookieService } from "ngx-cookie-service";
import { RiskRequest } from "../Modelos/RiskService/RiskRequest";
import { from } from "rxjs";
import { ConfiguracionesService } from "../configuraciones/configuraciones.service";
import { Ramo } from "../configuraciones/Ramo";
import { ArrayType } from "@angular/compiler";
import Swal from "sweetalert2";
import { ValidacionExclusionRequestDto } from "../Modelos/ValidacionExclusionRequestDto";
import { ParametrizacionService } from "../parametrizacion/parametrizacion.service";


declare let abrirModal: Function;
declare let cerrarModal: Function;
declare let mostrarLoader: Function;
declare let ocultarLoader: Function;
declare let actualizarCampos: Function;
declare let mostrarToast: Function;
declare let convertirAMoneda: Function;
declare let formatearFecha: Function;
declare let obtenerFecha: Function;
declare let validarFormatoFecha: Function;
declare let validarFormatoCorreo: Function;
declare let validarAlfanumerico: Function;
declare let soloLetras: Function;
declare let actualizarRangoFechas: Function;
declare let renderizarDatePickers: Function;
declare let ocultarTooltips: Function;
declare let cerrarToasts: Function;

@Component({
  selector: "poliza",
  templateUrl: "./poliza.component.html",
  styleUrls: ["poliza.componet.css"]
})
export class PolizaComponent implements OnInit {
  @ViewChild(ProductoComponent, { static: false }) producto;
  @ViewChild(TextosComponent, { static: false }) texto;
  @ViewChild(IntermediariosComponent, { static: false }) intermediarios;
  @ViewChild('uploadFormAutos', { static: false }) uploadFormAutos: any;
  @ViewChild('uploadForm', { static: false }) uploadForm: any;


  constructor(
    private polizaService: PolizaService,
    private intermediarioService: IntermediariosService,
    private parametrizacionEnlacesService: ParametrizacionEnlacesService,
    private cookieService: CookieService,
    private configuracionService : ConfiguracionesService,
    private parametrizacionService: ParametrizacionService
  ) {}
  mostrarLoader: boolean = true;

  tiposCliente = [
    { value: 1, text: "PERSONA NATURAL" },
    { value: 2, text: "PERSONA JURÍDICA" },
    { value: 3, text: "Unión temporal o Consorcio sin NIT" },
    { value: 4, text: "Unión temporal o Consorcio con NIT" },
  ];

  tiposClienteFiltrado = [];

  generos = [
    { value: "M", text: "Masculino" },
    { value: "F", text: "Femenino" },
  ];

  tiposEmpresa = [];
  tiposAsociado = [];
  colaboradoresAsociados: Colaborador[] = [];
  agencias = [];
  puntosVenta = [];
  ramos = [];
  tiposDocumento = [];
  tiposDocumentoTomador = [];
  tiposDocumentoAsegurado = [];
  FechaExpTomadorFieldActivate: boolean;
  claveIntermediario: string;
  usuarioIntermediario: boolean;

  actividadesEconomicas = [];
  ocupaciones = [];
  departamentos = [];
  municipios = [];
  estadosCiviles = [];
  duplicados = [];
  colaborador: Colaborador;
  UsuarioSise: string;
  NUsuarioSise: string;
  tempParticipante: BuscarPersonaPlantilla;
  tempTomador: BuscarPersonaPlantilla;
  tempAsegurado: BuscarPersonaPlantilla;
  tempBeneficiario: BuscarPersonaPlantilla;
  tempGobernabilidad: BuscarPersonaPlantilla;
  participanteTomadorId: number;
  terceroAfectadoId: number;
  esTerceroAfectado: boolean;
  cod_Agente: number;
  plantillaPersonaNueva: PersonaNueva;
  personaGobernabilidad: PersonaNueva;
  personaEncontrada: Participante;
  configuracionGobernabilidad: any;

  flagPersonaEncontrada: boolean;
  flagCrearPersona: boolean;
  flagEditarPersona: boolean;
  flagEmision: boolean;
  flagPersonaGobernabilidadNueva: boolean;
  flagConsorcioConNit: boolean;
  flagGobernabilidad: boolean;
  puedeEditarParticipantes: boolean;
  busquedaTresParametros: boolean;
  resultadosBeneficiario: Persona[];
  esCorrelativa: boolean;
  asociadoAEditar: PersonaGobernabilidad;

  nombreConsorcio: string;
  emision: Poliza;
  gobernabilidad: PersonaGobernabilidad;
  personasGobernabilidad: PersonaGobernabilidad[];
  respuestaEmision: any;
  modalRCE: any;
  pdf: string;
  pdfComprobante: string;
  botonHabilitadoEmision: boolean = false;
  // Variable que indica si muestran los mensajes de cargando emision poliza
  mostrarMensajesEmision: boolean = true;
  // Mensajes de carga que se mostrarán mientras se construye la poliza
  mensajesCarga = [
    "Un momento por favor, no te desconectes...",
    "Tu solicitud está siendo procesada, por favor espera...",
    "Estableciendo registros...",
    "Estamos construyendo la poliza...",
  ];

  // Índice del mensaje de carga actual
  indiceMensaje = 0;
  ramo45 :  string;
  ramo47 : string;
  ramo74 : string;
  responseJsonRamos : any = {};
  codigosRamos : number[];
  arrayRamos: Ramo[];
  inSnFormato_Fucc: number;
  inSnFormato_FuccValidate: number;
  personaGlobal: BuscarPersonaPlantilla;
  moduloActual: string;
  documentCodesFinleco: { [key: string]: number } = {};

  correoElectronico: string = '';
  correoCC: string = '';
  showSmallModal: boolean = false;
  showUploadModal: boolean = false;
  showUploadModalOrdinario: boolean = false;
  smallModalMessage: string = '';
  selectedFile: File | null = null;
  tipoPersona: string = '1'; 
  validarTipoPerson: number;
  documentosSeleccionados: { [key: string]: File } = {};
  polizaDatos: Poliza;

  mensajeModal: string = '';
 showModalExclusion: boolean = false;
  mensajeAutorizacionUsuario: string = '';

  async ngOnInit() {
    //ocultarLoader();
    this.codigosRamos = environment.codigosRamos;
    let arrayRamos: Ramo[] = []; // Array de tipo Ramo
     for (let codigo of this.codigosRamos) {
      let response = await this.configuracionService.consultarTopexRamo(codigo);


       // Crear instancia de la clase Ramo con los datos obtenidos y agregarla al array
       let ramo = new Ramo(
         response["iN_cod_ramo"],
         response["vC_descripcionramo"],
        response["nM_ValorTope"]
       );

       // Agregar la instancia de Ramo al array
       arrayRamos.push(ramo);
     }
    this.arrayRamos = arrayRamos;
    this.configuracionService.arrayRamos = this.arrayRamos;
    console.log("responseJSONRamos",this.arrayRamos);

    this.tempParticipante = new BuscarPersonaPlantilla();
    this.tempTomador = new BuscarPersonaPlantilla();
    this.tempAsegurado = new BuscarPersonaPlantilla();
    this.tempBeneficiario = new BuscarPersonaPlantilla();
    this.FechaExpTomadorFieldActivate =
      environment.FechaExpTomadorFieldActivate;
    this.esCorrelativa = false;
    this.flagCrearPersona = false;
    this.flagPersonaEncontrada = false;
    this.flagEditarPersona = false;
    this.flagEmision = false;
    this.flagConsorcioConNit = false;
    this.busquedaTresParametros = false;
    this.esTerceroAfectado = false;
    this.puedeEditarParticipantes = true;

    this.personaEncontrada = null;
    this.plantillaPersonaNueva = new PersonaNueva();

    this.emision = new Poliza();

    this.respuestaEmision = {
      nroPoliza: "",
      estado: "",
      error: "",
    };

    this.modalRCE = {
      ramo: null,
      agencia: null,
      numeroPoliza: null,
    };

    this.claveIntermediario = "";
    this.usuarioIntermediario = false;

    let actividadesEconomicas =
      await this.polizaService.consultarActividadesEconomicas();
    this.actividadesEconomicas = [
      ...this.actividadesEconomicas,
      ...actividadesEconomicas.map((element) => {
        return {
          codigoActividadEconomica: element.codigoActividadEconomica,
          nombreActividadEconomica: element.nombreActividadEconomica,
        };
      }),
    ];

    let ocupaciones = await this.polizaService.consultarOcupaciones();
    this.ocupaciones = [
      ...this.ocupaciones,
      ...ocupaciones.map((element) => {
        return {
          codigoOcupacion: element.codigoOcupacion,
          nombreOcupacion: element.nombreOcupacion,
        };
      }),
    ];

    let departamentos = await this.polizaService.consultarDepartamentos();
    this.departamentos = [
      ...this.departamentos,
      ...departamentos.map((element) => {
        return {
          codigoDepartamento: element.codigoDepartamento,
          nombreDepartamento: element.nombreDepartamento,
        };
      }),
    ];

    let estadosCivilesResult =
      await this.polizaService.consultarEstadosCiviles();

    this.estadosCiviles = [
      ...this.estadosCiviles,
      ...estadosCivilesResult.map((element) => {
        return {
          codigoEstadoCivil: element.codigoEstadoCivil,
          nombreEstadoCivil: element.nombreEstadoCivil,
        };
      }),
    ];

    let tiposDocumentoResult =
      await this.polizaService.consultarTiposDocumento();
    this.tiposDocumento = [
      ...this.tiposDocumento,
      ...tiposDocumentoResult.map((element) => {
        return {
          value: element.codigoTipoDocumento,
          text: element.nombreTipoDocumento,
        };
      }),
    ];

    let ramosResult = await this.polizaService.consultarRamos();
    this.ramos = [
      ...ramosResult.map((element) => {
        return { value: element.codigo_ramo, text: element.nombre };
      }),
    ];

    this.resultadosBeneficiario = [];

    let tiposAsociadoResult = await this.polizaService.obtenerTiposAsociado();
    this.tiposAsociado = [
      ...tiposAsociadoResult.map((element) => {
        return {
          value: element.codigo_asociado,
          text: element.asociado.toUpperCase(),
        };
      }),
    ];

    this.cargarAgencias();

    if (sessionStorage.getItem("cod_agt") && sessionStorage.getItem("cod_tagt"))
      this.consultarColaborador();

    actualizarCampos();

    // abrirModal("modalAvisoInicial");

    abrirModal("modalAvisoInicial");

    this.restablecerTomador();
    this.restablecerAsegurado();

    ocultarLoader();

    this.mostrarLoader = false;

    this.botonHabilitadoEmision = true;
    this.mostrarMensajesEmision = false;
  }

  async cargarAgencias() {
    let codigoSucursal = 0,
      codigoAgente = "0",
      codigoTipoAgente = 0;
    const cod_suc = sessionStorage.getItem("cod_suc"),
      cod_agt = sessionStorage.getItem("cod_agt"),
      cod_tagt = sessionStorage.getItem("cod_tagt"),
      cod_usuario = sessionStorage.getItem("cod_usuario"),
      cod_usuario_sise = sessionStorage.getItem("codusuariosise");

    if (cod_suc) codigoSucursal = parseInt(cod_suc);
    if (cod_agt) {
      codigoAgente = cod_agt;
      this.claveIntermediario = codigoAgente + "";
      this.usuarioIntermediario = true;
    }
    if (cod_tagt) codigoTipoAgente = parseInt(cod_tagt);
    if (cod_usuario) this.emision.codigoUsuario = cod_usuario;
    if (cod_usuario_sise) this.emision.codigoUsuarioSISE = cod_usuario_sise;

    let parametrosAgencias: Parametro[] = [
      { llave: "cod_sucursal", valor: codigoSucursal.toString() },
      { llave: "cod_agente", valor: codigoAgente.toString() },
      { llave: "cod_tipo_agente", valor: codigoTipoAgente.toString() },
      {
        llave: "Cod_UsuarioSISE",
        valor: sessionStorage.getItem("codusuariosise")
          ? sessionStorage.getItem("codusuariosise")
          : "0",
      },
    ];

    let result = await this.polizaService.consultarAgencias(
      true,
      parametrosAgencias
    );

    let agenciasResult = result.map((element) => {
      return { value: element.codigoSucursal, text: element.nombreSucursal };
    });

    this.agencias = [...this.agencias, ...agenciasResult];
    this.emision.agencia = null;
  }

  async cargarPuntosVenta(numeroAgencia: number = 0) {
    if (numeroAgencia != 0) this.emision.agencia = numeroAgencia;
    const agencia = this.emision.agencia == null ? 0 : this.emision.agencia;
    const codigoUsuarioSISE = sessionStorage.getItem("codusuariosise");
    console.log(
      "RequestPuntosVentas",
      "Agencia: " + agencia + "codigoUsuarioSISE: " + codigoUsuarioSISE
    );
    let result = await this.polizaService.consultarPuntosVenta(
      agencia,
      codigoUsuarioSISE ? codigoUsuarioSISE : ""
    );
    console.log("ResponsePuntosVentas", result);
    let puntosVentaResult = result.map((element) => {
      return { value: element.codigo_punto_venta, text: element.nombre };
    });

    this.puntosVenta = puntosVentaResult;

    this.emision.puntoVenta = null;
    actualizarCampos();
  }

  async cargarMunicipios() {
    this.alternarLoader();

    let codigoDepartamento =
      this.plantillaPersonaNueva.Direcciones[0].CodigoDepartamento;
    codigoDepartamento = codigoDepartamento == null ? -1 : codigoDepartamento;

    let municipiosResult = await this.polizaService.consultarMunicipios(
      codigoDepartamento
    );
    this.municipios = [
      ...municipiosResult.map((element) => {
        return {
          codigoMunicipio: element.codigoMunicipio,
          nombreMunicipio: element.nombreMunicipio,
        };
      }),
    ];

    this.plantillaPersonaNueva.Direcciones[0].CodigoMunicipio = null;
    actualizarCampos();
    this.alternarLoader();
  }

  async cargarMunicipiosEmision() {
    this.alternarLoader();

    let codigoDepartamento = this.emision.CodigoDepartamento;
    codigoDepartamento = codigoDepartamento == null ? -1 : codigoDepartamento;

    const municipiosResult = await this.polizaService.consultarMunicipios(
      codigoDepartamento
    );
    this.municipios = [
      ...municipiosResult.map((element) => {
        return {
          codigoMunicipio: element.codigoMunicipio,
          nombreMunicipio: element.nombreMunicipio,
        };
      }),
    ];

    this.emision.CodigoMunicipio = null;
    actualizarCampos();
    this.alternarLoader();
  }

  async mostrarGobernabilidad(persona) {
    abrirModal("modalGobernabilidad", false);
    this.flagGobernabilidad = true;
    this.personasGobernabilidad = [];
    this.tempGobernabilidad = new BuscarPersonaPlantilla();
    this.gobernabilidad = new PersonaGobernabilidad();
    this.flagCrearPersona = true;
    await this.cargarPlantilla(persona, this.personaGobernabilidad);
  }

  async cargarPlantilla(persona, personaGobernabilidad = null) {
    let plantilla = personaGobernabilidad;
    if (personaGobernabilidad == null) plantilla = this.plantillaPersonaNueva;

    this.flagCrearPersona = true;
    plantilla.IdPersona = persona.inIdPersona;
    plantilla.CodigoTipoDocumento =
      persona.inCod_tipo_doc != 0 ? persona.inCod_tipo_doc : null;
    plantilla.NumeroDocumento = persona.vcNro_doc;

    if (personaGobernabilidad)
      plantilla.PrimerApellido = Persona.obtenerRazonSocial(
        persona.vcNombreUno,
        persona.vcNombreDos,
        persona.vcApellidoUno,
        persona.vcApellidoDos
      );
    else plantilla.PrimerApellido = persona.vcApellidoUno;

    plantilla.Telefonos[0] = {
      IdTelefono: 1,
      CodigoTipoTelefono: 2,
      NumeroTelefono: persona.vcTelefono,
    };
    plantilla.Telefonos[2] = {
      IdTelefono: 3,
      CodigoTipoTelefono: 10,
      NumeroTelefono: persona.vcEmail,
    };
    plantilla.Direcciones[0] = {
      IdDireccion: 1,
      CodigoTipoDireccion: 1,
      CodigoPais: 1,
      NumeroDireccion: persona.vcDireccion,
      CodigoDepartamento:
        persona.inCod_departamento != 0 ? persona.inCod_departamento : null,
      CodigoMunicipio: 0,
    };
    await this.cargarMunicipios();
    plantilla.Direcciones[0].CodigoMunicipio =
      persona.inCod_municipio != 0 ? persona.inCod_municipio : null;
  }

  prepararPersona(persona: BuscarPersonaPlantilla, modulo: string) {
    let plantilla: BuscarPersonaPlantilla;

    if (modulo == "tomador" || modulo.includes("participante")) {
      persona.tipoPersona = "T";
      plantilla = modulo.includes("participante")
        ? this.tempParticipante
        : this.tempTomador;
    } else if (modulo == "asegurado") {
      persona.tipoPersona = "A";
      plantilla = this.tempAsegurado;
    } else if (modulo == "beneficiario") {
      persona.tipoPersona = "B";
      plantilla = this.tempBeneficiario;
    } else if (modulo == "gobernabilidad") {
      persona.tipoPersona = "T";
      plantilla = this.tempGobernabilidad;
    }

    if (this.emision.ramo == null) {
      mostrarToast("Debe seleccionar un ramo");
      return;
    }

    persona.ramo = this.emision.ramo;
    return plantilla;
  }

  restablecerPlantillas(modulo: string, personaEncontrada: boolean = true) {
    if (modulo == "tomador") {
      this.tempParticipante.inicializarPlantilla();
      this.tempAsegurado.inicializarPlantilla();
      this.tempBeneficiario.inicializarPlantilla();
    } else if (modulo == "asegurado") {
      this.tempParticipante.inicializarPlantilla();
      this.tempTomador.inicializarPlantilla();
      this.tempBeneficiario.inicializarPlantilla();
    } else if (modulo == "participanteConsorcioSinNit") {
      this.tempAsegurado.inicializarPlantilla();
      this.tempTomador.inicializarPlantilla();
      this.tempBeneficiario.inicializarPlantilla();
    } else if (modulo == "participanteConsorcioConNit") {
      this.tempAsegurado.inicializarPlantilla();
      this.tempTomador.inicializarPlantilla();
      this.tempBeneficiario.inicializarPlantilla();
    }

    if (!personaEncontrada)
      if (
        modulo == "tomador" ||
        modulo == "asegurado" ||
        modulo == "participanteConsorcioConNit"
      )
        this.abrirModalPersona();
  }

  async consultarPersona(persona: BuscarPersonaPlantilla, modulo: string) {
    // this.flagCrearPersona = true;
    // this.restablecerPlantillas(modulo, false);
    // actualizarCampos();
    this.personaGlobal = persona;
    this.alternarLoader();
    if (modulo == "beneficiario") {
      if (!this.validarBeneficiario(persona)) return;
    } else {
      if (!this.validarPersona(persona, modulo)) {
        this.alternarLoader();
        return;
      }
    }

    let plantilla: BuscarPersonaPlantilla = this.prepararPersona(
      persona,
      modulo
    );
    let resultado = await this.polizaService.consultarPersona(persona);
    this.moduloActual = modulo;

    if(modulo == "tomador"){
      this.inSnFormato_Fucc = resultado[0].inSnFormato_Fucc;
      const valorRamo = this.getValorRamoSeleccionado();
      if(valorRamo === 45){
        if(this.inSnFormato_Fucc == 1){
          this.inSnFormato_FuccValidate = 1
        }else{
          this.inSnFormato_FuccValidate = 0
        }
      }else{
        this.inSnFormato_FuccValidate = 1
        this.inSnFormato_Fucc = 1;
      }   
    }else{
      this.inSnFormato_Fucc = 1;
      this.inSnFormato_FuccValidate = 1
    }
   
    //let autorizacionUsuario = await this.polizaService.ConsultarAutorizacionUsuario(persona);
    this.restablecerPlantillas(modulo);

    if (resultado[0].inSnVeto != 0) {
      mostrarToast(resultado[0].strMensaje);
    } else if (resultado[0].registros) {
      //Hay duplicados
      this.duplicados = await this.polizaService.obtenerDuplicados(
        resultado[0].inCod_tipo_doc,
        resultado[0].vcNro_doc
      );
      abrirModal("modalDuplicados");
    } else {
      if (
        resultado[0].inIdPersona == 0 ||
        (modulo != "beneficiario" && resultado[0].inIdCodAsegurado == 0)
      ) {
        //No se encontró la persona
        resultado[0].inCod_tipo_doc = persona.tipoDocumento;
        resultado[0].vcApellidoUno = persona.primerApellido;
        resultado[0].vcNro_doc = persona.numeroDocumento;
        await this.cargarPlantilla(resultado[0]);
        if (this.esCorrelativa) {
          mostrarToast("No se encontró la persona.");
        } else {
          this.restablecerPlantillas(modulo, false);
          actualizarCampos();
        }
      } else {
        //Sí se encontró la persona //Es un registro único
        let persona: Persona = Persona.crearPersona(
          resultado[0].inIdPersona,
          resultado[0].vcNombreUno,
          resultado[0].vcNombreDos,
          resultado[0].vcApellidoUno,
          resultado[0].vcApellidoDos,
          resultado[0].inCod_tipo_doc,
          this.tiposDocumento.find(
            (x) => x.value == resultado[0].inCod_tipo_doc
          ).text,
          resultado[0].vcNro_doc,
          resultado[0].inIdCodAsegurado
        );
        switch (modulo) {
          case "participanteConsorcioSinNit":
          case "participanteConsorcioConNit":
            this.personaEncontrada = new Participante(
              persona,
              resultado[0].inIdCodAsegurado,
              0
            );
            await this.consultarCupos(this.personaEncontrada);
            this.flagPersonaEncontrada = true;
            if (modulo == "participanteConsorcioConNit")
              this.asociarParticipante();
            break;
          case "tomador":
            if (
              resultado[0].inCod_tipo_doc == 3 &&
              resultado[0].inSnGobernabilidad == 0
            ) {
              await this.mostrarGobernabilidad(resultado[0]);
              mostrarToast(resultado[0].strMensaje, 15000);
              this.configuracionGobernabilidad =
                await this.polizaService.obtenerValidacionesGobernabilidad(
                  resultado[0].inIdPersona
                );
            }
            await this.consultarCupos(persona);
            this.emision.tomador = persona;
            this.emision.tomador.fechaExpedicion =
              this.tempTomador.fechaExpedicion;
            if (this.emision.tipoCliente == 4) {
              await this.cargarParticipantesConsorcio(persona.codigoAsegurado);
              setTimeout(async () => await this.calcularCuposConsorcio(), 2000);
              this.puedeEditarParticipantes = false;
            }
            break;
          case "asegurado":
            this.emision.asegurado = persona;
            this.emision.asegurado.fechaExpedicion =
              this.tempAsegurado.fechaExpedicion;
            if (
              resultado[0].inCod_tipo_doc == 3 &&
              resultado[0].inSnGobernabilidad == 0
            ) {
              await this.mostrarGobernabilidad(resultado[0]);
              mostrarToast(resultado[0].strMensaje, 15000);
              this.configuracionGobernabilidad =
                await this.polizaService.obtenerValidacionesGobernabilidad(
                  resultado[0].inIdPersona
                );
            }
            break;
          case "beneficiario":
            this.emision.beneficiario = persona;
            this.emision.beneficiario.fechaExpedicion =
              this.tempBeneficiario.fechaExpedicion;
            break;
          case "gobernabilidad":
            await this.consultarPersonaGobernabilidad();
            break;
        }
        actualizarCampos();
        plantilla.inicializarPlantilla();
      }
    }
    this.alternarLoader();
    //console.log("Emision Tomador Final",this.emision.tomador);
    //console.log("Emision Participantes Final",this.emision.participantes);
  }

  async cargarParticipantesConsorcio(codigoAsegurado: number) {
    this.emision.participantes = [];
    let participantesConsorcio: any[] =
      await this.polizaService.consultarConsorcio(codigoAsegurado);
    participantesConsorcio.forEach(async (x) => {
      let persona: Persona = Persona.crearPersona(
        x.id_persona,
        x.nombre,
        x.nombre2,
        x.apellido1,
        x.apellido2,
        x.cod_tipo_doc,
        this.tiposDocumento.find((y) => y.value == x.cod_tipo_doc).text,
        x.nro_documento,
        x.cod_aseg_cons
      );
      await this.consultarCupos(persona);
      this.emision.participantes = [
        ...this.emision.participantes,
        new Participante(persona, persona.codigoAsegurado, x.pje_participacion),
      ];
    });
  }

  async consultarPersonaUnParametro(primerApellido: string) {
    this.alternarLoader();
    let personas: any = await this.polizaService.consultarPersonaUnParametro(
      primerApellido
    );
    this.resultadosBeneficiario = [];
    if (personas.length == 0) {
      mostrarToast("No se encontraron resultados para la búsqueda.");
    } else {
      personas.forEach((x) => {
        let tipoDocumentoText = "";
        try {
          tipoDocumentoText = this.tiposDocumento.find(
            (y) => y.value == x.tipo_doc
          ).text;
        } catch (e) {
          tipoDocumentoText = "";
          console.error("Tipo de documento no encontrado: " + x.tipo_doc);
        }
        let persona: Persona = Persona.crearPersona(
          x.id_persona,
          "",
          "",
          x.apellido,
          "",
          x.tipo_doc,
          tipoDocumentoText,
          x.nro_doc,
          x.codigo_raseg
        );
        this.resultadosBeneficiario.push(persona);
      });
    }
    this.alternarLoader();
  }

  validarPersonaNueva(tipoDocumento: number) {
    //console.log("PersonaNuevaTipoDocumento", tipoDocumento);
    if ([1, 2, 5, 20].includes(tipoDocumento))
      return (
        this.plantillaPersonaNueva.CodigoActividadEconomica != null &&
        this.plantillaPersonaNueva.CodigoOcupacion != null &&
        this.plantillaPersonaNueva.EstadoCivil != null &&
        this.plantillaPersonaNueva.Genero &&
        this.plantillaPersonaNueva.FechaNacimiento &&
        this.plantillaPersonaNueva.LugarNacimiento &&
        this.plantillaPersonaNueva.CodigoTipoDocumento != null &&
        this.plantillaPersonaNueva.NumeroDocumento &&
        this.plantillaPersonaNueva.PrimerApellido &&
        this.plantillaPersonaNueva.PrimerNombre &&
        this.plantillaPersonaNueva.Direcciones[0].CodigoDepartamento != null &&
        this.plantillaPersonaNueva.Direcciones[0].CodigoMunicipio != null &&
        this.plantillaPersonaNueva.Direcciones[0].NumeroDireccion &&
        this.plantillaPersonaNueva.Telefonos[0].NumeroTelefono &&
        this.plantillaPersonaNueva.Telefonos[2].NumeroTelefono
      );
    else {
      this.plantillaPersonaNueva.EstadoCivil = 1;
      this.plantillaPersonaNueva.CodigoOcupacion = 230;
      this.plantillaPersonaNueva.CodigoActividadEconomica = 0;
      this.plantillaPersonaNueva.Genero = "M";
      return (
        this.plantillaPersonaNueva.CodigoTipoDocumento != null &&
        this.plantillaPersonaNueva.NumeroDocumento &&
        this.plantillaPersonaNueva.PrimerApellido &&
        this.plantillaPersonaNueva.Direcciones[0].CodigoDepartamento != null &&
        this.plantillaPersonaNueva.Direcciones[0].CodigoMunicipio != null &&
        this.plantillaPersonaNueva.Direcciones[0].NumeroDireccion &&
        this.plantillaPersonaNueva.Telefonos[0].NumeroTelefono &&
        this.plantillaPersonaNueva.Telefonos[2].NumeroTelefono
      );
    }
  }

  async crearPersona() {
    this.alternarLoader();
    let persona = null;
    let modulo = "";
    if (this.flagGobernabilidad) {
      if (this.tempGobernabilidad.esValido()) {
        persona = this.tempGobernabilidad;
        modulo = "gobernabilidad";
      }
    } else if (this.tempParticipante.esValido()) {
      persona = this.tempParticipante;
      modulo = "participanteConsorcioSinNit";
    } else if (this.tempTomador.esValido()) {
      persona = this.tempTomador;
      modulo = "tomador";
    } else if (this.tempAsegurado.esValido()) {
      persona = this.tempAsegurado;
      modulo = "asegurado";
    }
    if (!this.validarPersonaNueva(persona.tipoDocumento)) {
      mostrarToast("No todos los campos son válidos.");
    } else {
      this.plantillaPersonaNueva.NumeroDocumento =
        this.plantillaPersonaNueva.NumeroDocumento.toString();
      let json = JSON.stringify(this.plantillaPersonaNueva);
      let response = await this.polizaService.crearPersona(json);
      let personaRisk = this.crearPersonaRisk(
        this.plantillaPersonaNueva,
        parseInt(`${environment.APIRiskPersonType}`, 10)
      );
      console.log("RequestValidarRisk: ", personaRisk);
      let detenerPersonaRiesgo = false;
      if (personaRisk === null) {
        mostrarToast(
          "Algunos datos no están correctamente diligenciados, por favor revíselos."
        );
        this.alternarLoader();
        return;
      } else {
        await (
          await this.polizaService.AuthorizeRisk()
        ).subscribe(
          async (res) => {
            //console.log("Token API Risk: ", res["token"]);
            await (
              await this.polizaService.ValidatePersonRisk(
                personaRisk,
                res["token"]
              )
            ).subscribe(async (resp) => {
              console.log("responseValidarRisk", resp);
              //console.log("responseValidarRisk_hasrisk", resp["hasRisk"]);
              if (Boolean(resp["hasRisk"])) {
                this.alternarLoader();
                mostrarToast(`${environment.APIRiskMessage}`);
                detenerPersonaRiesgo = true;
                return;
              }
              if (!detenerPersonaRiesgo) {
                let response = await this.polizaService.crearPersona(json);
                //console.log("Se crea la persona, no tiene riesgos");
                this.flagCrearPersona = false;
                this.flagPersonaEncontrada = false;
                this.flagEditarPersona = false;
                //mostrarToast("No tiene riesgo, se crea personurwa");

                if (modulo.length > 0 && persona != null) {
                  if (
                    ["tomador", "asegurado", "gobernabilidad"].includes(modulo)
                  )
                    cerrarModal("modalPersona");
                  if (response.tipo == "OK") {
                    this.consultarPersona(persona, modulo);
                    if (this.emision.tipoCliente == 4) {
                      abrirModal("modalConsorcioConNit", false);
                      this.flagConsorcioConNit = false;
                    }
                  }
                }
                this.alternarLoader();
              }
            });
          },
          (error) => {
            mostrarToast(`Error al comunicarse con Risk, intente nuevamente!`);
            this.alternarLoader();
            detenerPersonaRiesgo = true;
            return;
          }
        );
      }
    }
  }

  abrirModalPersona(personaAEditar: Persona = null) {
    abrirModal("modalPersona", false);
    if (personaAEditar != null) {
      this.personaEncontrada = Object.create(personaAEditar);
      this.flagPersonaEncontrada = true;
      this.flagEditarPersona = true;
      actualizarCampos();
    }
  }

  cancelarModalPersona() {
    this.personasGobernabilidad = [];
    this.flagPersonaEncontrada = false;
    this.flagCrearPersona = false;
    this.flagEditarPersona = false;
    this.tempParticipante.inicializarPlantilla();
    this.plantillaPersonaNueva.restablecerPersonaNueva();
    actualizarCampos();
    cerrarModal("modalPersona");
  }

  asociarBeneficiario() {
    this.alternarLoader();
    this.emision.beneficiario = this.resultadosBeneficiario.find(
      (x) => x.idPersona == this.terceroAfectadoId
    );
    this.resultadosBeneficiario = [];
    this.terceroAfectadoId = null;
    this.alternarLoader();
  }

  asociarParticipanteTomador() {
    let participante = this.emision.participantes.find(
      (x) => x.idPersona == this.participanteTomadorId
    );
    this.emision.tomador = Persona.crearTomadorDesdeParticipante(participante);
    this.calcularCuposConsorcio();
  }

  asociarParticipante(editarPersona: boolean = false) {
    let participante = this.personaEncontrada;
    this.alternarLoader();

    if (editarPersona) {
      let index = this.emision.participantes.findIndex(
        (x) => x.idPersona == participante.idPersona
      );
      this.emision.participantes[index] = participante;
      this.flagEditarPersona = false;
    } else {
      let puedeAsociarse = true;
      this.emision.participantes.forEach((element) => {
        if (element.idPersona == participante.idPersona) {
          mostrarToast("Este participante ya está asociado.");
          puedeAsociarse = false;
        }
      });

      if (
        !participante.porcentajeParticipacion &&
        this.emision.tipoCliente != 4
      ) {
        puedeAsociarse = false;
        mostrarToast("El porcentaje de participación no es válido.");
      } else if (
        this.emision.tipoCliente != 4 &&
        (participante.porcentajeParticipacion == 0 ||
          participante.porcentajeParticipacion > 100)
      ) {
        puedeAsociarse = false;
        mostrarToast("El porcentaje de participación no es válido.");
      }

      if (!puedeAsociarse) {
        this.alternarLoader();
        return;
      }

      this.flagCrearPersona = false;
      this.emision.participantes = [
        ...this.emision.participantes,
        Object.create(participante),
      ];
    }

    this.calcularCuposConsorcio();

    cerrarModal("modalPersona");
    this.personaEncontrada = null;
    this.flagPersonaEncontrada = false;
    this.alternarLoader();
  }

  calcularCuposConsorcio() {
    this.alternarLoader();
    let cupoOperativo = 0,
      cupoDisponible = 0,
      cumulo = 0;
    if (this.emision.tomador.idPersona != 0) {
      this.emision.participantes.forEach((x) => {
        (cupoOperativo += parseFloat(x.cupoOperativo.replace(/,/g, ""))),
          (cupoDisponible += parseFloat(x.cupoDisponible.replace(/,/g, ""))),
          (cumulo += parseFloat(x.cumulo.replace(/,/g, "")));
      });
      this.emision.tomador.cupoOperativo = convertirAMoneda(cupoOperativo);
      this.emision.tomador.cupoDisponible = convertirAMoneda(cupoDisponible);
      this.emision.tomador.cumulo = convertirAMoneda(cumulo);
      actualizarCampos();
    }
    this.alternarLoader();
  }

  validarPorcentaje(participante: Participante) {
    let porcentaje = participante.porcentajeParticipacion;
    if (porcentaje <= 0 && porcentaje) {
      mostrarToast("El porcentaje debe ser mayor a 0.");
    }

    let sumaPorcentajes = 0;
    this.emision.participantes.forEach((a) => {
      if (a.idPersona != participante.idPersona) {
        sumaPorcentajes += a.porcentajeParticipacion;
      }
    });
    sumaPorcentajes = sumaPorcentajes + porcentaje;
    if (sumaPorcentajes > 100) {
      mostrarToast(
        "El porcentaje o la suma de pocentajes no debe ser mayor a 100."
      );
      participante.porcentajeParticipacion = null;
    }
  }

  validarCupo(persona: Persona) {
    persona.cupoOperativo = convertirAMoneda(persona.cupoOperativo);
  }

  validarPersona(persona: BuscarPersonaPlantilla, modulo: string) {
    this.validarFormatoFecha(persona, "fechaExpedicion");
    let mensaje = "";
    if (persona.tipoDocumento == 0) mensaje += "<li>Tipo documento</li>";
    if (persona.numeroDocumento == "") mensaje += "<li>Número documento</li>";
    if (persona.primerApellido == "") mensaje += "<li>Primer apellido</li>";
    if (
      persona.fechaExpedicion == "" &&
      environment.FechaExpTomadorFieldActivate &&
      ["tomador", "asegurado", "beneficiario"].includes(modulo) &&
      ![3, 7, 19].includes(persona.tipoDocumento)
    ) {
      mensaje += "<li>Fecha Expedición</li>";
    }

    if (mensaje != "") {
      mostrarToast(`<ul><li>Campos requeridos:</li>${mensaje}</ul>`);
      return false;
    }
    return true;
  }

  validarBeneficiario(persona: BuscarPersonaPlantilla) {
    if (!this.busquedaTresParametros) {
      let mensaje = "";
      if (persona.primerApellido == "") mensaje += "<li>Primer apellido</li>";

      if (mensaje != "") {
        mostrarToast(`<ul><li>Campos requeridos:</li>${mensaje}</ul>`);
        return false;
      }
      return true;
    } else {
      return this.validarPersona(persona, "beneficiario");
    }
  }

  borrarParticipante(idParticipante: number) {
    this.emision.participantes.splice(
      this.emision.participantes.findIndex(
        (x) => x.idPersona == idParticipante
      ),
      1
    );
    if (
      this.emision.participantes.length == 0 &&
      this.emision.tipoCliente != 4
    ) {
      this.emision.tipoCliente = null;
      actualizarCampos();
    }
  }

  restablecerTomador() {
    this.emision.tomador.restablecerPersona();
    this.participanteTomadorId = null;
    this.tempTomador.inicializarPlantilla();
    //console.log(this.emision.tomador);
  }

  restablecerAsegurado() {
    this.emision.asegurado.restablecerPersona();
    this.tempAsegurado.inicializarPlantilla();
  }

  restablecerBeneficiario() {
    this.emision.beneficiario.restablecerPersona();
    this.tempBeneficiario.inicializarPlantilla();
    this.busquedaTresParametros = false;
    this.resultadosBeneficiario = [];
    this.terceroAfectadoId = null;
  }

  consorcioChange() {
    this.emision.participantes = [];
    actualizarCampos();
  }

  seriedadDeLaOfertaChange() {
    this.tempTomador.inicializarPlantilla();
    actualizarCampos();
  }

  parametrosBeneficiarioSwitchChange() {
    this.tempBeneficiario.inicializarPlantilla();
    actualizarCampos();
  }

  cargarTiposDocumento() {
    this.tiposDocumentoAsegurado = this.tiposDocumento.filter((x) =>
      [3, 19, 7].includes(x.value)
    ); //NIT, NEX, SEN
    this.validarTipoPerson  = this.emision.tipoCliente;
    if (this.emision.tipoCliente != null) {
      if (this.emision.tipoCliente == 1)
        //Persona Natural
        this.tiposDocumentoTomador = this.tiposDocumento.filter((x) =>
          [1, 2, 5, 20].includes(x.value)
        );
      //CC, CE, Pasaporte, PEP
      else {
        this.tiposDocumentoTomador = this.tiposDocumentoAsegurado;
        if (this.emision.tipoCliente == 3) this.abrirModalPersona();
      }
    } else {
      this.tiposDocumentoTomador = [];
    }

    this.emision.seriedadDeLaOferta = this.emision.tipoCliente == 3;

    this.flagConsorcioConNit = this.emision.tipoCliente == 4;

    this.emision.participantes = [];
    this.restablecerTomador();
    this.restablecerAsegurado();
    actualizarCampos();
  }

  actualizarCampos() {
    actualizarCampos();
  }

  cerrarAvisoInicial() {
    cerrarModal("modalAvisoInicial");
    cerrarModal("modalAvisoEstado");
  }

  cerrarModalConsorcioConNit() {
    this.flagConsorcioConNit = true;
    cerrarModal("modalConsorcioConNit");
  }

  async consultarCupos(persona: Persona) {
    this.alternarLoader();
    let cupos = await this.polizaService.consultarCupoOperativo(
      persona.codigoAsegurado,
      this.emision.ramo
    );
    let fechaVigencia = new Date(cupos.fecha_vigencia);
    persona.fechaCupovigenciahasta = fechaVigencia.toLocaleDateString(
      "es-CO",
      {}
    );
    if (fechaVigencia < new Date() && this.emision.ramo != 74)
      mostrarToast(
        "El cupo está vencido, estuvo vigente hasta " +
          persona.fechaCupovigenciahasta
      );
    persona.cupoOperativo = convertirAMoneda(cupos.imp_cupo_asignado);
    persona.cupoDisponible = convertirAMoneda(cupos.imp_cupo_disponible);
    persona.cumulo = convertirAMoneda(cupos.imp_cumulo);
    actualizarCampos();
    this.alternarLoader();
  }

  async modificarCupo(persona: Persona) {
    this.alternarLoader();
    let cupoOperativo = parseFloat(persona.cupoOperativo.replace(/,/g, ""));
    let modificarResult = await this.polizaService.modificarCupoOperativo(
      persona.codigoAsegurado,
      this.emision.ramo,
      cupoOperativo,
      this.emision.codigoUsuario,
      persona.fechaCupovigenciahasta
    );
    mostrarToast(
      modificarResult.sn_modificado == -1
        ? "Cupo modificado exitosamente."
        : "No se pudo modificar el cupo."
    );
    this.consultarCupos(persona);
    //this.emision.tomador = persona;
    this.alternarLoader();
  }

  verificarRamo() {
    if (this.emision.ramo == 74) {
      abrirModal("modalVerificarRCE", false);
      this.tiposClienteFiltrado = this.tiposCliente.filter((x) => x.value != 3);
    } else {
      this.tiposClienteFiltrado = this.tiposCliente;
    }
  }

  cancelarVerificarRCE() {
    // this.emision.ramo=null;
    cerrarModal("modalVerificarRCE");
  }

  verificarRCE() {
    cerrarModal("modalVerificarRCE");
  }

  convertirTextoAMoneda(texto) {
    return convertirAMoneda(texto + "");
  }

  alternarLoader() {
    if (this.mostrarLoader) ocultarLoader();
    else mostrarLoader();
    this.mostrarLoader = !this.mostrarLoader;
  }

  soloLetras(modelo: object, propiedad: string) {
    if (modelo[propiedad]) modelo[propiedad] = soloLetras(modelo[propiedad]);
  }

  validarFormatoNombre(modelo: object, propiedad: string) {
    if (modelo[propiedad])
      modelo[propiedad] = modelo[propiedad].replace(
        /[^a-zA-Z á-úÁ-ÚñÑ0-9]+/g,
        ""
      );
  }

  validarFormatoCorreo(modelo: object, propiedad: string) {
    let correo = modelo[propiedad];
    if (correo.length > 0)
      if (!validarFormatoCorreo(modelo[propiedad])) {
        mostrarToast("El formato de correo no es válido.");
        modelo[propiedad] = "";
      }
  }

  validarFormatoDireccion(modelo: object, propiedad: string) {
    if (modelo[propiedad])
      modelo[propiedad] = modelo[propiedad].replace(/[^a-zA-Z0-9.# -]/g, "");
  }

  formatearFecha(modelo, propiedad) {
    if (modelo[propiedad])
      modelo[propiedad] = formatearFecha(modelo[propiedad]);
  }

  validarFormatoFecha(modelo, propiedad) {
    if (modelo[propiedad]) {
      let fecha = modelo[propiedad];
      if (fecha.length > 0)
        if (!validarFormatoFecha(fecha)) {
          mostrarToast("El formato de fecha no es válido.");
          modelo[propiedad] = "";
        }
    }
  }

  validarFormatoNumero(modelo, propiedad) {
    if (modelo[propiedad])
      modelo[propiedad] = modelo[propiedad].replace(/\D/g, "");
  }

  validarNumeroCorrelativa(modelo, propiedad) {
    this.validarFormatoNumero(modelo, propiedad);
    if (modelo[propiedad] > 12)
      modelo[propiedad] = modelo[propiedad].slice(0, 12);
  }

  validarTipoDocumentoModal() {
    if (
      this.plantillaPersonaNueva.CodigoTipoDocumento == 2 ||
      this.plantillaPersonaNueva.CodigoTipoDocumento == 5
    ) {
      this.plantillaPersonaNueva.NumeroDocumento = validarAlfanumerico(
        this.plantillaPersonaNueva.NumeroDocumento
      );
    } else {
      if (this.plantillaPersonaNueva.NumeroDocumento)
        this.plantillaPersonaNueva.NumeroDocumento =
          this.plantillaPersonaNueva.NumeroDocumento.toString().replace(
            /\D/g,
            ""
          );
    }
  }

  calcularTotal() {
    let gastosEmision = parseFloat(
      this.emision.gastosEmision.replace(/,/g, "")
    );
    let valorPrima = parseFloat(this.emision.totalPrimaNeta.replace(/,/g, ""));
    let iva = parseFloat(this.emision.iva);
    this.emision.total = convertirAMoneda(
      gastosEmision + valorPrima + ((gastosEmision + valorPrima) * iva) / 100
    );
  }

  validarGastos() {
    this.emision.gastosEmision = convertirAMoneda(this.emision.gastosEmision);
  }

  async consultarGastosExpedicion() {
    if (this.intermediarios.intermediarios.length == 0) {
      mostrarToast(
        "No hay información de intermediarios disponible para proceder."
      );
      return null;
    }
    let intermediario: Intermediario = this.intermediarios.intermediarios[0];
    let gastosExpedicion = await this.polizaService.consultarGastosExpedicion(
      this.emision.ramo,
      this.emision.agencia,
      intermediario.cod_tipo_inter,
      parseInt(intermediario.clave)
    );
    let valorGastosExpedicion = 0;
    if (Array.isArray(gastosExpedicion)) {
      if (gastosExpedicion.length > 0) {
        let numeroAmparosActivos = this.producto.producto.amparos.filter(
          (x) => x.activo
        ).length;
        if (numeroAmparosActivos == 1)
          valorGastosExpedicion = gastosExpedicion.find(
            (x) => x.aplica_cobertura == -1
          ).vlr_emision;
        else if (numeroAmparosActivos > 1)
          valorGastosExpedicion = gastosExpedicion.find(
            (x) => x.aplica_cobertura == 0
          ).vlr_emision;
      }
    }
    this.emision.gastosEmision = convertirAMoneda(valorGastosExpedicion);
    return valorGastosExpedicion;
  }

  validarFormularioAntesDeEmitir(): boolean {
    if (!this.emision.agencia || !this.emision.ramo || !this.emision.tomador.codigoAsegurado) {
      this.mensajeModal = 'Debe diligenciar correctamente toda la información requerida: Agencia, Ramo y Tomador.';
      this.showModalExclusion = true;
      return false;
    }
  
    return true;
  }  

  async abrirModalEmision() {
    if (!this.validarFormularioAntesDeEmitir()) return;
    let valorPrima = 0;
    let productoValidate = Object.create(this.producto.producto);
    
    const valorNumerico = Number(productoValidate.valorContrato.replace(/,/g, '')) || 0;
    const request: ValidacionExclusionRequestDto = {
      codExclusion: 1,
      codSucursal: this.emision.agencia || 0,
      codRamo: this.emision.ramo || 0,
      nroPoliza: 0,
      codAsegurado: this.emision.tomador.codigoAsegurado,
      codGrupo: 0,
      codOperacion: 0,
      codProducto: 0,
      codCobertura: 0,
      snPolOneroso: false,
      fechaEmision: new Date(),
      sumaAsegurada: valorNumerico, 
      primaAnual: 25000,
      codTipoPoliza: 1,
      importePagoStro: 0,
      snTomador: true,
      snAsegurado: false,
      snGarantizado: false,
      snBeneficiario: false,
      snStro: false
    };

    const response = await this.polizaService.validarExclusion(request).toPromise();

    // 3. Si genera evento, mostrar el modal de advertencia y detener el flujo
    if (response.generaEvento) {
      this.mensajeModal = response.mensaje;
      this.showModalExclusion = true;
      return;
    }

    this.alternarLoader();
    
    this.flagEmision = true;
    let producto = Object.create(this.producto.producto);
    producto.amparos.forEach((amparo) => {
      if (amparo.valor_prima && amparo.activo) {
        valorPrima += parseFloat(amparo.valor_prima.replace(/,/g, ""));
      }
    });
    this.emision.totalPrimaNeta = this.validarPrimaMinima(
      producto.amparos,
      convertirAMoneda(valorPrima)
    );
    valorPrima = parseFloat(this.emision.totalPrimaNeta.replace(/,/g, ""));
    let gastosExpedicion = await this.consultarGastosExpedicion();
    if (gastosExpedicion == null) {
      this.alternarLoader();
      return;
    }
    let iva = await this.polizaService.consultarIva();
    this.emision.total = convertirAMoneda(
      gastosExpedicion +
        valorPrima +
        ((gastosExpedicion + valorPrima) * iva) / 100
    );
    this.emision.iva = iva + "%";
    abrirModal("modalConfirmarEmision");
    this.alternarLoader();
  }

  cerrarModalEmision() {
    this.flagEmision = false;
    cerrarModal("modalConfirmarEmision");
    this.mostrarMensajesEmision = false;
    this.botonHabilitadoEmision = true;
  }

  cerrarModalRespuesta() {
    cerrarModal("modalRespuesta");
    this.ngOnInit();
    window.location.reload();
  }

  confirmarEmision() {
    //this.cerrarModalEmision();
    this.emitir();
  }

  cambiarMensaje() {
    let mensajeActual = document.getElementById("mensajesCargando");
    mensajeActual.style.opacity = "0";
    setTimeout(() => {
      this.indiceMensaje++;
      if (this.indiceMensaje >= this.mensajesCarga.length) {
        this.indiceMensaje = 0;
      }
      mensajeActual.innerHTML = this.mensajesCarga[this.indiceMensaje];
      mensajeActual.style.opacity = "1";
    }, 500);
  }

  async emitir() {
    this.mostrarMensajesEmision = true;
    this.botonHabilitadoEmision = false;
    setInterval(() => {
      this.cambiarMensaje();
    }, 5000);
    this.alternarLoader();
    if (
      this.emision.seriedadDeLaOferta &&
      this.emision.tipoCliente == 3 &&
      this.emision.participantes.length > 0
    ) {
      if (this.nombreConsorcio == "") {
        mostrarToast("El consorcio debe tener un nombre.");
        this.alternarLoader();
        return;
      }
      let duplicarResultado = await this.polizaService.duplicarPersona(
        this.emision.tomador.idPersona,
        this.nombreConsorcio
      );
      if (duplicarResultado == 0) {
        mostrarToast(
          "No se pudo asociar el participante principal como tomador."
        );
        this.alternarLoader();
        return;
      } else {
        // let valorCupo = 0;

        // if (parseFloat(this.emision.tomador.cupoOperativo.replace(/,/g, "")) > 150000000)
        // {
        //    valorCupo = 150000000;
        //}
        //else
        //{
        //    valorCupo= parseFloat(this.emision.tomador.cupoOperativo.replace(/,/g, ""));

        // }

        this.emision.tomador.codigoAsegurado = duplicarResultado.inCod_aseg;
        this.emision.tomador.razonSocial = duplicarResultado.vcRazonSocial;
        this.emision.tomador.numeroDocumento = duplicarResultado.vcNro_doc;
        this.emision.tomador.idPersona = duplicarResultado.inId_persona;
        this.emision.tomador.tipoDocumentoText = this.tiposDocumento.find(
          (x) => x.value == duplicarResultado.nmCod_tipo_doc
        ).text;
        this.emision.tomador.tipoDocumento = duplicarResultado.nmCod_tipo_doc;
        this.emision.tomador.apellidoUno = duplicarResultado.vcRazonSocial;

        /* let modificarCupo =await this.polizaService.modificarCupoOperativo(
                    duplicarResultado.inCod_aseg,
                    this.emision.ramo,
                    valorCupo,
                    this.emision.codigoUsuarioSISE);


                    if (modificarCupo.sn_modificado==-1)
                    {
                        this.emision.tomador.cupoOperativo = convertirAMoneda(valorCupo);
                        this.emision.tomador.cupoDisponible = convertirAMoneda(valorCupo);
                    }
*/
        // let persona: BuscarPersonaPlantilla=new BuscarPersonaPlantilla();
        // persona.idPersona= duplicarResultado.inId_persona;
        // persona.numeroDocumento=this.emision.tomador.numeroDocumento;
        // persona.primerApellido=this.nombreConsorcio;
        // persona.tipoDocumento=this.emision.tomador.tipoDocumento;
        // persona.ramo=this.emision.ramo;
        // let resultado=await this.polizaService.consultarPersona(persona);
        // if(resultado.length>0){
        //     let tomador: Persona=Persona.crearPersona(resultado[0].inIdPersona,
        //         resultado[0].vcNombreUno,
        //         resultado[0].vcNombreDos,
        //         resultado[0].vcApellidoUno,
        //         resultado[0].vcApellidoDos,
        //         resultado[0].inCod_tipo_doc,
        //         this.tiposDocumento.find(x => x.value==resultado[0].inCod_tipo_doc).text,
        //         resultado[0].vcNro_doc,
        //         resultado[0].inIdCodAsegurado);
        //     this.emision.tomador=tomador;
        //     this.emision.participantes.forEach(async x => {
        //        this.asociarParticipanteAConsorcio(tomador, x);
        //     });
        // }
      }
    }

    this.flagEmision = true;

    this.emision.producto = Object.create(this.producto.producto);
    this.emision.producto.amparos = this.emision.producto.amparos.filter(
      (x) => x.activo
    );

    if (!this.emision.tipoCliente) {
      mostrarToast("El tipo cliente debe ser diligenciado.");
      this.alternarLoader();
      return;
    }

    if (this.inSnFormato_FuccValidate == 0) {
      mostrarToast("falta informacion por llenar, por favor actualizar informacion del Tomador, por favor valide el formulario");
      this.alternarLoader();
      return;
    }

    if (!this.emision.producto.giroNegocio) {
      mostrarToast("El tipo de negocio debe ser diligenciado.");
      this.alternarLoader();
      return;
    }

    if (!this.emision.producto.clausulado) {
      mostrarToast("El clausulado debe ser diligenciado.");
      this.alternarLoader();
      return;
    }

    let emision: Poliza = this.emision;
    if (emision.producto.amparos.length == 0) {
      mostrarToast("La póliza no puede no tener amparos.");
      this.alternarLoader();
      return;
    }
    if (!this.validarSumaAsegurada(emision.producto.amparos)) {
      this.alternarLoader();
      return;
    }
    emision.textoAclaratorio = this.texto.textoAclaratorio;
    emision.intermediarios = this.intermediarios.intermediarios;
    console.log("RequestEmision", emision);
    let emisionResult = await this.polizaService.emitirPoliza(emision);
    try {
      if (emisionResult[0].codEstadoProceso == 7) {
        this.respuestaEmision.error = emisionResult[0].mensajeError;
        this.respuestaEmision.estado = emisionResult[0].estado;
      } else if (emisionResult[0].codEstadoProceso == 6) {
        this.respuestaEmision.estado = emisionResult[0].estado;
        emisionResult.forEach((element) => {
          this.respuestaEmision.estado +=
            "\n" + element.mensajeError.replace(/(, )/g, "\n");
        });
        this.respuestaEmision.nroPoliza = emisionResult[0].nroPoliza;
        // tslint:disable-next-line: max-line-length
        this.emision.restablecerPoliza();
      } else {
        this.respuestaEmision = emisionResult[0];
        // tslint:disable-next-line: max-line-length
        this.emision.restablecerPoliza();
      }
      this.flagEmision = false;
      this.cerrarModalEmision();
      this.mostrarMensajesEmision = false;
      this.botonHabilitadoEmision = true;
      abrirModal("modalRespuesta", false);
      this.esCorrelativa = false;
      console.log("Resultado Emisión: " + JSON.stringify(emisionResult));
    } catch (e) {
      console.log(e.toString());
      mostrarToast(emisionResult.title);
    }
    this.alternarLoader();
  }

  async asociarParticipanteAConsorcio(
    consorcio: Persona,
    participante: Participante
  ) {
    if (
      await this.polizaService.asociarParticipanteConsorcio(
        consorcio,
        participante
      )
    ) {
      mostrarToast(
        `${participante.razonSocial} añadido al consorcio ${this.nombreConsorcio} correctamente.`
      );
    } else {
      mostrarToast(
        `No se pudo añadir el participante ${participante.razonSocial} al consorcio ${this.nombreConsorcio}.`
      );
    }
  }

  async consultarColaborador() {
    const cod_suc = sessionStorage.getItem("cod_suc"),
      cod_agt = sessionStorage.getItem("cod_agt"),
      cod_tagt = sessionStorage.getItem("cod_tagt"),
      cod_usuario = sessionStorage.getItem("cod_usuario"),
      cod_usuario_sise = sessionStorage.getItem("codusuariosise");
    console.log("cod_tagt", cod_tagt);
    console.log("cod_agt", cod_agt);
    console.log("cod_usuario", cod_usuario);
    console.log("cod_usuario_sise", cod_usuario_sise);

    const resultado =
      await this.parametrizacionEnlacesService.consultarColaboradores(
        parseInt(cod_agt),
        parseInt(cod_tagt)
      );

    if (resultado.length == 0) {
    } else {
      console.log("Resultado", resultado);
      this.colaborador = await resultado.filter(
        (x) => x.vcCod_UsuarioSISE === cod_usuario_sise
      )[0];
      console.log("id", this.colaborador);
      console.log("estado", this.colaborador.in_Estado);

      if (this.colaborador.in_Estado === 0) {
        this.UsuarioSise = cod_usuario_sise;
        this.NUsuarioSise = this.colaborador.vc_ApellidoUno;
        console.log("cod_usuario_sise", cod_usuario_sise);

        abrirModal("modalAvisoEstado");
        mostrarToast(
          `El usuario se encuentra inactivo no puede continuar : ${cod_usuario_sise}.`
        );
      }
    }
  }

  aceptarMensajeSesion() {
    let returnUrl = this.cookieService.get("returnUrl");
    window.location.replace(returnUrl);
  }
  validarPrimaMinima(amparos: Amparo[], primaTotalNeta: string) {
    let amparosActivos = amparos.filter((x) => x.activo);
    let primaNeta = parseFloat(primaTotalNeta.replace(/,/g, ""));
    let primaMinima = amparosActivos[0].vr_prima_minima;
    let primaTotal = 0;
    if (primaNeta < primaMinima) {
      mostrarToast(
        "Los valores de primas de los amparos serán reajustados para cumplir con la prima neta mínima."
      );
      let numeroAmparos = amparosActivos.length;
      let diferencia = primaMinima - primaNeta;
      let valorASumar = parseFloat(
        convertirAMoneda(diferencia / numeroAmparos).replace(/,/g, "")
      );
      amparosActivos.forEach((x) => {
        let valorPrima = parseFloat(
          (!x.valor_prima ? "0" : x.valor_prima).replace(/,/g, "")
        );
        valorPrima += valorASumar;
        x.valor_prima = convertirAMoneda(valorPrima);
        primaTotal += valorPrima;
      });
      if (primaTotal != primaMinima) {
        let diff = primaMinima - primaTotal;
        amparosActivos[0].valor_prima = convertirAMoneda(
          parseFloat(
            amparosActivos[0].valor_prima.toString().replace(/,/g, "")
          ) + diff
        );
        primaTotal += diff;
      }
    } else {
      primaTotal = primaNeta;
    }
    return convertirAMoneda(primaTotal);
  }

  validarSumaAsegurada(amparos: Amparo[]) {
    let valorAsegurado = 0,
      valorMaximo = 0;
    amparos.forEach((amparo) => {
      if (amparo.valor_asegurado && amparo.activo) {
        valorAsegurado += parseFloat(amparo.valor_asegurado.replace(/,/g, ""));
      }
    });
    if (this.emision.ramo == 45)
      valorMaximo = this.arrayRamos.find(objeto => objeto.iN_cod_ramo === 45).nM_ValorTope;
    if (this.emision.ramo == 47)
      valorMaximo = this.arrayRamos.find(objeto => objeto.iN_cod_ramo === 47).nM_ValorTope;
    if (this.emision.ramo == 74)
      valorMaximo = this.arrayRamos.find(objeto => objeto.iN_cod_ramo === 74).nM_ValorTope;
    if (valorAsegurado > valorMaximo) {
      mostrarToast(
        `El valor asegurado supera ${convertirAMoneda(valorMaximo.toString())}.`
      );
      return false;
    }
    return true;
  }

  async consultarCorrelativa() {
    this.alternarLoader();
    if (!this.validarModalRCE) {
      this.alternarLoader();
      return;
    }
    let correlativa: any = await this.polizaService.consultarCorrelativa(
      this.modalRCE.ramo,
      this.modalRCE.agencia,
      this.modalRCE.numeroPoliza
    );
    let intermediario: Intermediario;
    let poliza = new Poliza();
    if (correlativa != null) {
      poliza.codigoProceso = correlativa.cod_proceso;
      poliza.ramo = 74;
      poliza.codigoUsuarioSISE = this.emision.codigoUsuarioSISE;
      // poliza.ramo=correlativa.codigo_ramo;
      poliza.agencia = correlativa.codigo_sucursal;
      await this.cargarPuntosVenta(poliza.agencia);
      poliza.puntoVenta = correlativa.cod_punto_venta;
      intermediario = await this.intermediarioService.consultarIntermediario(
        "I",
        correlativa.codigo_agente,
        poliza.ramo,
        poliza.agencia,
        poliza.puntoVenta
      );
      poliza.intermediarios = [intermediario];

      let fechaExpedicion = new Date(
        correlativa.fecha_emision
      ).toLocaleDateString("es-CO", {});
      let fechaVigenciaDesde = new Date(
        correlativa.fecha_desde
      ).toLocaleDateString("es-CO", {});
      let fechafinContrato = new Date(
        correlativa.fecha_final_contrato
      ).toLocaleDateString("es-CO", {});
      poliza.producto = {
        amparos: [],
        clausulado: correlativa.cod_clausulado,
        fechaExpedicion: fechaExpedicion,
        fechaFinConstitucion: fechafinContrato,
        fechaVigenciaDesde: fechaVigenciaDesde,
        giroNegocio: correlativa.cod_giro_negocio,
        objetoContrato: null,
        numeroContrato: correlativa.nro_licitacion,
        valorContrato: convertirAMoneda(correlativa.valor_contrato),
      };
      let tomador = new Persona();
      tomador.idPersona = correlativa.id_persona_tomador;
      tomador.apellidoUno = correlativa.apellido1_tomador;
      tomador.codigoAsegurado = correlativa.tomador;
      tomador.numeroDocumento = correlativa.nro_doc_tomador;
      tomador.razonSocial = correlativa.razon_social_tomador;
      tomador.tipoDocumento = correlativa.tipo_doc_tomador;
      tomador.tipoDocumentoText = this.tiposDocumento.find(
        (x) => x.value == tomador.tipoDocumento
      ).text;
      poliza.tomador = tomador;
      poliza.tipoCliente = correlativa.cod_tipo_cliente;
      let asegurado = new Persona();
      asegurado.idPersona = correlativa.id_persona_aseg;
      asegurado.apellidoUno = correlativa.apellido1_aseg;
      asegurado.codigoAsegurado = correlativa.asegurado;
      asegurado.numeroDocumento = correlativa.nro_doc_aseg;
      asegurado.razonSocial = correlativa.razon_social_aseg;
      asegurado.tipoDocumento = correlativa.tipo_doc_aseg;
      asegurado.tipoDocumentoText = this.tiposDocumento.find(
        (x) => x.value == asegurado.tipoDocumento
      ).text;

      poliza.CodigoDepartamento = correlativa.departamento == 0
        ? null
        : correlativa.departamento;

      await this.cargarMunicipiosEmision();

      poliza.CodigoMunicipio = correlativa.municipio == 0
        ? null
        : correlativa.municipio;

      poliza.asegurado = asegurado;
      this.emision = poliza;
      this.esCorrelativa = true;
    } else {
      mostrarToast(
        "No se encontró póliza correlativa con los parámetros especificados."
      );
      this.emision.ramo = null;
      this.esCorrelativa = false;
    }
    cerrarModal("modalVerificarRCE");
    this.alternarLoader();
  }

  validarModalRCE() {
    let mensaje = "";
    if (!this.modalRCE.ramo) mensaje += "<li>Producto / Ramo</li>";
    if (!this.modalRCE.agencia) mensaje += "<li>Agencia</li>";
    if (this.modalRCE.numeroPoliza == "") mensaje += "<li>Número Póliza</li>";

    if (mensaje != "") {
      mostrarToast(`<ul><li>Campos requeridos:</li>${mensaje}</ul>`);
      return false;
    }
    return true;
  }

  aceptarConsorcioConNit() {
    let participacion = 0;
    this.emision.participantes.forEach(
      (x) => (participacion += x.porcentajeParticipacion)
    );
    if (participacion != 100)
      mostrarToast("El porcentaje de participación debe sumar 100.");
    else if (this.emision.participantes.length <= 1)
      mostrarToast("El consorcio debe tener más de un participante.");
    else abrirModal("modalConfirmacionConsorcioConNit");
  }

  confirmarConsorcioConNit() {
    this.nombreConsorcio = this.emision.tomador.apellidoUno;
    this.emision.participantes.forEach(
      async (x) =>
        await this.asociarParticipanteAConsorcio(this.emision.tomador, x)
    );

    this.cerrarModalConsorcioConNit();
    this.cancelarConfirmacionConsorcioConNit();
  }

  cancelarConfirmacionConsorcioConNit() {
    cerrarModal("modalConfirmacionConsorcioConNit");
  }

  async imprimirPdf() {
    let pass = await this.polizaService.EncriptPassword();
    let ParamsToken = {
      IdAplicacion: environment.applicationId,
      Ip: "IpStringToken",
      user: "CUMPLIMIENTOAPIPRINTTEMPLATES",
      password: pass,
    };
    let jsonToken = JSON.stringify(ParamsToken);
    let token = "";
    (await this.polizaService.obtenerToken(jsonToken)).subscribe(
      async (res) => {
        let parameters = {
          id_Aplication: 12,
          id_Ramo: this.emision.ramo,
          id_Sucursal: this.emision.puntoVenta,
          nro_Poliza: this.respuestaEmision.numeroPoliza,
          nro_endoso: 0,
          cod_usuario_sise: this.emision.codigoUsuarioSISE,
          ip: "IpUsuarioPruebas",
          mac: "MacUsuarioPruebas",
        };
        let jsonPolicy = JSON.stringify(parameters);
        (
          await this.polizaService.imprimirComprobante(jsonPolicy, res["token"])
        ).subscribe(async (resp) => {
          printJS({
            printable: resp["arrBytes"],
            base64: true,
            type: "pdf",
          });
          (
            await this.polizaService.imprimirPoliza(jsonPolicy, res["token"])
          ).subscribe(async (resp) => {
            printJS({
              printable: resp["arrBytes"],
              base64: true,
              type: "pdf",
            });
          });
        });
      }
    );
  }

  imprimirPdfComprobante() {
    printJS({
      printable: this.pdf,
      base64: true,
      type: "pdf",
    });
  }

  async modificarTerceroAfectado() {
    if (this.esTerceroAfectado) {
      let result = await this.polizaService.obtenerTerceroAfectado();
      if (result.txt_param) {
        let terceroAfectado = JSON.parse(result.txt_param);
        let tipoDocumento =
          terceroAfectado.NmCodTipoDoc == 10
            ? "Sin identificación"
            : this.tiposDocumento.find(
                (x) => x.value == terceroAfectado.NmCodTipoDoc
              ).text;
        let persona = Persona.crearPersona(
          terceroAfectado.InCodPersona,
          "",
          "",
          terceroAfectado.VcPrimerApellido,
          "",
          terceroAfectado.NmCodTipoDoc,
          tipoDocumento,
          terceroAfectado.VcNroDoc,
          terceroAfectado.InCodAseg
        );
        this.emision.beneficiario = persona;
      }
    } else {
      this.emision.beneficiario.restablecerPersona();
      this.tempBeneficiario.inicializarPlantilla();
    }
  }

  cancelarSeleccionDuplicado() {
    cerrarModal("modalDuplicados");
  }

  cancelarConsultarAutorizacionUsuario() {
    cerrarModal("modalConsultarAutorizacionUsuario");
  }
  abrirModalCargarDocumentos() {
    cerrarModal("modalCargarDocumentos");
  }
  

  onFileSelected(event: any, tipoDocumento: string): void {
    const file: File = event.target.files[0];
    if (file) {
      this.documentosSeleccionados[tipoDocumento] = file;
    }
  }

  validateEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  async enviarCorreo() {
    if (!this.correoElectronico || !this.validateEmail(this.correoElectronico)) {
      Swal.fire({
        icon: 'warning',
        title: 'Correo inválido',
        text: 'Por favor ingrese un correo electrónico válido.',
        confirmButtonText: 'Aceptar',
      });
      return;
    }

    try {
      mostrarLoader();
      const correoCC = ''; // Puedes agregar un valor de copia oculta si es necesario
      const response = await this.polizaService.enviarCorreo(this.correoElectronico, correoCC);
      ocultarLoader();
      if (response) {
        Swal.fire({
          icon: 'success',
          title: 'Correo enviado',
          text: 'Correo enviado exitosamente.',
          confirmButtonText: 'Aceptar',
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Hubo un error al enviar el correo. Por favor intente de nuevo.',
        confirmButtonText: 'Aceptar',
      });
    }
  }

  getNombreRamoSeleccionado(): string | undefined {
    const ramoSeleccionado = this.ramos.find(r => r.value === this.personaGlobal.ramo);
    return ramoSeleccionado ? ramoSeleccionado.text : undefined;
  }

  getValorRamoSeleccionado(): number | undefined {
    const ramoSeleccionado = this.ramos.find(r => r.value === this.personaGlobal.ramo);
    return ramoSeleccionado ? ramoSeleccionado.value : undefined;
  }

  getNombreAgenciaSeleccionada(): string | undefined {
    const agenciaSeleccionada = this.agencias.find(
      (a) => a.value === this.polizaDatos.agencia
    );
    return agenciaSeleccionada ? agenciaSeleccionada.text : undefined;
  }
  
async uploadDocumentAutos(event: Event): Promise<void> {
  event.preventDefault();
  this.polizaDatos = this.emision;
  this.documentCodesFinleco = {};
  const tipo = this.tipoPersona.toUpperCase();
  if (tipo === 'PN') {
    this.documentCodesFinleco = {
      fucc: 16,
      cedula: 17,
      camaraComercio: 45,
      certificadoAccionistas: 36
    };
  } else if (tipo === 'PJ') {
    this.documentCodesFinleco = {
      fucc: 16,
      cedula: 17,
      camaraComercio: 6,
      certificadoAccionistas: 36
    };
  }

  const requeridosPersonaNatural = ['fucc', 'cedula'];
  const requeridosPersonaJuridica = ['cedula', 'fucc', 'camaraComercio','certificadoAccionistas' ];

  const tipoPersona = this.tipoPersona.toUpperCase(); // 'PN' o 'PJ'
  const documentosFaltantes: string[] = [];
  const requeridos = tipoPersona === 'PN' ? requeridosPersonaNatural : requeridosPersonaJuridica;

  // Validar requeridos
  for (const doc of requeridos) {
    if (!this.documentosSeleccionados[doc]) {
      documentosFaltantes.push(doc);
    }
  }

  if (documentosFaltantes.length > 0) {
    Swal.fire({
      icon: 'warning',
      title: tipoPersona === 'PN' ? 'Persona Natural' : 'Persona Jurídica',
      text: `Faltan documentos requeridos: ${documentosFaltantes.map(d => d.toUpperCase()).join(', ')}`,
      confirmButtonText: 'Aceptar'
    });
    return;
  }

  try {
    mostrarLoader();
    let resultado = await this.polizaService.consultarPersona(this.personaGlobal);

    // Agrupar documentos por tipo
    const obj_documentos: any[] = [];

    for (const [key, file] of Object.entries(this.documentosSeleccionados)) {
      const fileBase64 = await this.convertFileToBase64(file);
      const codTipo = this.documentCodesFinleco[key];

      // Verificar si ya existe un grupo para ese cod_tipo_documento_adjunto
      let grupo = obj_documentos.find(d => d.cod_tipo_documento_adjunto === codTipo);
      if (!grupo) {
        grupo = {
          cod_tipo_documento_adjunto: codTipo,
          Archives: []
        };
        obj_documentos.push(grupo);
      }

      grupo.Archives.push({
        nombre_documento: file.name,
        documento: fileBase64.split(',')[1]
      });
    }
     let usuarioResponse =await this.parametrizacionService.consultarUsuario(sessionStorage.getItem("codusuariosise"));
    // Armar el payload completo que espera el backend
    const payload = {
      origen: 1,
      tipo_persona: this.tipoPersona,
      id_pv: 1,
      codigo_agencia: this.polizaDatos.agencia,
      agencia: this.getNombreAgenciaSeleccionada(),
      codigo_ramo: this.personaGlobal.ramo,
      ramo: this.getNombreRamoSeleccionado(),
      numero_poliza: 1,
      fecha_expedicion: new Date(),
      placa: 'ABC123',
      correo: usuarioResponse!.email || '',
      usuario: sessionStorage.getItem("codusuariosise"),
      tipo_documento: this.personaGlobal.tipoDocumento,
      nro_documento: this.personaGlobal.numeroDocumento.toString(),
      nombres_apellidos: this.duplicados[0].nombres || '',
      cod_usuario: sessionStorage.getItem("codusuariosise"),
      mail_admon: usuarioResponse!.email || '', 
      nombres_y_apellidos: this.duplicados[0].nombres || '',
      obj_documentos: obj_documentos
    };
  
    // Enviar al servicio
    const response = await this.polizaService.uploadMultipleFilesAutos(payload);
    ocultarLoader();

    Swal.fire({
      icon: 'success',
      title: 'Información',
      text: response.descripcion_rta,
      confirmButtonText: 'Aceptar'
    });

    this.closeUploadModalOrdinario();

        this.documentosSeleccionados = {}; 
        this.uploadFormAutos.resetForm();
  } catch (error) {
    ocultarLoader();
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'Ocurrió un error al subir los archivos.',
      confirmButtonText: 'Aceptar'
    });
        this.documentosSeleccionados = {}; 
        this.uploadFormAutos.resetForm();
  }
}


  
  async uploadDocument(event: Event): Promise<void> {
    event.preventDefault();
    this.polizaDatos = this.emision;

    // Definir códigos por tipo de documento
    const documentCodes = {
        'fucc': 108,
        'cedula': 81,
        'camaraComercio': 82,
        'certificadoAccionistas': 83
    };

        if (!this.documentosSeleccionados['fucc']) {
            Swal.fire({
                icon: 'warning',
                title: 'Persona Natural',
                text: 'Por favor, selecciona el archivo requerido.',
                confirmButtonText: 'Aceptar',
            });
            return;
        }

    try {
        const archivos: any[] = [];
        mostrarLoader();
        for (const [key, file] of Object.entries(this.documentosSeleccionados)) {
            const fileBase64 = await this.convertFileToBase64(file);
            archivos.push({
                TipoDocumento: key, // Nombre del tipo de documento
                CodigoDocumento: documentCodes[key], // Código del documento según la lista
                FileBase64: fileBase64.split(',')[1], // Obtener la parte Base64
                FileName: file.name,
                FileExtension: file.name.split('.').pop()
            });
        }
        let usuarioResponse =await this.parametrizacionService.consultarUsuario(sessionStorage.getItem("codusuariosise"));
        const payload = {
            InId_Aplicacion: environment.applicationId,
            InTipoDocumento: this.personaGlobal.tipoDocumento != null ? this.personaGlobal.tipoDocumento : 1,
            StrNroDocumento: this.personaGlobal.numeroDocumento.toString(),
            StrPrimerApellido: this.duplicados[0].nombres || '',
            InIdPersona: this.personaGlobal.idPersona,
            CrTipoPersona: this.tipoPersona,
            Correo: usuarioResponse!.email || '',
            Usuario: sessionStorage.getItem("codusuariosise"),
            InCodRamo: this.personaGlobal.ramo,
            Ramo: this.getNombreRamoSeleccionado(),
            CodUsuario: sessionStorage.getItem("codusuariosise"),
            Agencia: this.polizaDatos.agencia,
            AgenciaNombre: this.getNombreAgenciaSeleccionada(),
            Archivos: archivos // Lista con todos los archivos
        };
        // Enviar la solicitud con todos los archivos
        const response = await this.polizaService.uploadMultipleFiles(payload);
        ocultarLoader();
        Swal.fire({
            icon: 'success',
            title: 'Información',
            text: response.descripcion_rta,
            confirmButtonText: 'Aceptar',
        });
        this.closeUploadModal();

        this.documentosSeleccionados = {}; 
        this.uploadForm.resetForm();
    } catch (error) {
        ocultarLoader();
        Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Ocurrió un error al subir los archivos.',
            confirmButtonText: 'Aceptar',
        });

        this.documentosSeleccionados = {}; 
        this.uploadForm.resetForm();
    }
}


// Método para convertir un archivo a Base64
private convertFileToBase64(file: File): Promise<string> {
    return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}


  openSmallModal(message: string): void {
    this.smallModalMessage = message;
    this.showSmallModal = true;
  }

  closeSmallModal(): void {
    this.showSmallModal = false;
    this.smallModalMessage = '';
    cerrarModal("modalConsultarAutorizacionUsuario");
  }

  openUploadModal() {
    this.showUploadModal = true; 
    this.tipoPersona = this.validarTipoPerson == 1 ? "PN": "PJ" ;
  }

    openUploadModalOrdinario() {
    this.showUploadModalOrdinario = true; 
    this.tipoPersona = this.validarTipoPerson == 1 ? "PN": "PJ" ;
  }
  
  closeUploadModal() {
    this.showUploadModal = false;
    this.selectedFile = null;
  }

  closeUploadModalOrdinario() {
    this.showUploadModalOrdinario = false;
    this.selectedFile = null;
  }

  abrirModalAutorizacionUsuario(): void {
  this.showModalExclusion = false;   
  abrirModal("modalConsultarAutorizacionUsuario"); 
  }

  async Validacion(): Promise<number> {
    let resultado = await this.polizaService.consultarPersona(this.personaGlobal);
    const request: ValidacionExclusionRequestDto = {
      codExclusion: 1,
      codSucursal: this.emision.agencia || 0,
      codRamo: this.emision.ramo || 0,
      nroPoliza: 0,
      codAsegurado: resultado[0].inIdCodAsegurado,
      codGrupo: 0,
      codOperacion: 0,
      codProducto: 0,
      codCobertura: 0,
      snPolOneroso: false,
      fechaEmision: new Date(),
      sumaAsegurada: 0,
      primaAnual: 0,
      codTipoPoliza: 1,
      importePagoStro: 0,
      snTomador: true,
      snAsegurado: false,
      snGarantizado: false,
      snBeneficiario: false,
      snStro: false
    };

    const response = await this.polizaService.validarExclusion(request).toPromise();
    this.mensajeAutorizacionUsuario = response.mensaje; 
    return response.generaEvento ? 0 : 1;
  }
  

  

  async seleccionarDuplicado(idPersona: number) {
    let persona;
    let modulo = "";
    this.personaGlobal.idPersona = idPersona;
    //let resultado = await this.polizaService.consultarPersona(this.personaGlobal);
    const resultado = await this.Validacion();
    this.personaGlobal.idPersona = 0;
    if(this.moduloActual == "tomador"){
      //this.inSnFormato_Fucc = resultado[0].inSnFormato_Fucc;
      this.inSnFormato_Fucc = resultado;
      const valorRamo = this.getValorRamoSeleccionado();
      if(valorRamo === 45){
        if(this.inSnFormato_Fucc == 1){
          this.inSnFormato_FuccValidate = 1
        }else{
          this.inSnFormato_FuccValidate = 0
        }
      }else{
        this.inSnFormato_FuccValidate = 1
        this.inSnFormato_Fucc = 1;
      }   
    }else{
      this.inSnFormato_Fucc = 1;
      this.inSnFormato_FuccValidate = 1
    }
    const valorRamo = this.getValorRamoSeleccionado();
    if(this.inSnFormato_Fucc == 0 && valorRamo == 45){
      cerrarModal("modalDuplicados"); 
      abrirModal("modalConsultarAutorizacionUsuario");
    }else{
      this.inSnFormato_FuccValidate = 1;
      if (this.flagGobernabilidad) {
        persona = this.tempGobernabilidad;
        modulo = "gobernabilidad";
      } else if (this.tempParticipante.esValido()) {
        persona = this.tempParticipante;
        modulo =
          this.emision.tipoCliente == 4
            ? "participanteConsorcioConNit"
            : "participanteConsorcioSinNit";
      } else if (this.tempTomador.esValido()) {
        persona = this.tempTomador;
        modulo = "tomador";
      } else if (this.tempAsegurado.esValido()) {
        persona = this.tempAsegurado;
        modulo = "asegurado";
      } else if (this.tempBeneficiario.esValido()) {
        persona = this.tempBeneficiario;
        modulo = "beneficiario";
      }
      persona.idPersona = idPersona;
      this.consultarPersona(persona, modulo);
      cerrarModal("modalDuplicados");
    } 
  }

  async consultarPersonaGobernabilidad() {
    this.alternarLoader();
    if (!this.validarPersona(this.tempGobernabilidad, "gobernabilidad")) {
      this.alternarLoader();
      return;
    }
    this.tempGobernabilidad.tipoPersona = "T";

    let result: any[] = await this.polizaService.consultarPersona(
      this.tempGobernabilidad
    );

    if (result[0].inSnVeto != 0) {
      mostrarToast(result[0].strMensaje);
      this.alternarLoader();
    } else {
      if (result[0].inIdPersona == 0) {
        this.flagPersonaGobernabilidadNueva = true;
        let persona = {
          inIdPersona: 1,
          inCod_tipo_doc: this.tempGobernabilidad.tipoDocumento,
          vcNro_doc: this.tempGobernabilidad.numeroDocumento,
          vcApellidoUno: this.tempGobernabilidad.primerApellido,
        };
        this.gobernabilidad.cargarGobernabilidad(persona);
        this.tempGobernabilidad.inicializarPlantilla();
        actualizarCampos();
        this.alternarLoader();
        return;
      } else {
        if (result[0].registros) {
          //Hay duplicados
          this.duplicados = await this.polizaService.obtenerDuplicados(
            result[0].inCod_tipo_doc,
            result[0].vcNro_doc
          );
          abrirModal("modalDuplicados");
          this.alternarLoader();
          return;
        } else if (
          this.personasGobernabilidad.findIndex(
            (x) => x.idPersona == result[0].inIdPersona
          ) != -1
        ) {
          mostrarToast("El asociado ya ha sido agregado.");
          this.alternarLoader();
          return;
        }
        this.gobernabilidad.restablecerGobernabilidad();
        this.gobernabilidad.cargarGobernabilidad(result[0]);
        this.tempGobernabilidad.inicializarPlantilla();
        actualizarCampos();
        this.alternarLoader();
      }
    }
  }

  async validarPersonaGobernabilidad() {
    if (this.gobernabilidad.exclusion) return true;

    let tipoAsociado = this.configuracionGobernabilidad.find(
      (x) => x.codigo_tipo_asociado === this.gobernabilidad.tipoPersona
    );
    if (tipoAsociado.sn_porcentaje) {
      if (!this.gobernabilidad.porcentajeParticipacion) {
        mostrarToast("El porcentaje es requerido.");
        return false;
      }
      if (
        this.gobernabilidad.porcentajeParticipacion < tipoAsociado.pje_minimo
      ) {
        mostrarToast(
          `El porcentaje del asociado no puede ser menor a ${tipoAsociado.pje_minimo}.`
        );
        return false;
      }
    }
    return true;
  }

  async agregarPersonaGobernabilidad() {
    this.alternarLoader();
    if (!this.validarPorcentajesGobernabilidad()) {
      this.alternarLoader();
      return;
    }

    if (this.gobernabilidad.exclusion) {
      if (
        !this.gobernabilidad.tipoEmpresa ||
        !this.gobernabilidad.tipoPersona
      ) {
        mostrarToast("No todos los campos están diligenciados correctamente.");
        this.alternarLoader();
        return;
      } else {
        this.gobernabilidad.razonSocial = "";
        this.gobernabilidad.idPersona = 0;
        this.gobernabilidad.tipoDocumento = 0;
        this.gobernabilidad.porcentajeParticipacion = 0;
      }
    } else if (!this.gobernabilidad.esValido()) {
      mostrarToast("No todos los campos están diligenciados correctamente.");
      this.alternarLoader();
      return;
    }

    if (!(await this.validarPersonaGobernabilidad())) {
      this.alternarLoader();
      return;
    }

    this.gobernabilidad.razonSocial = Persona.obtenerRazonSocial(
      this.gobernabilidad.primerNombre,
      this.gobernabilidad.segundoNombre,
      this.gobernabilidad.primerApellido,
      this.gobernabilidad.segundoApellido
    );

    let tipoEmpresa = this.tiposEmpresa.find(
      (x) => x.value == this.gobernabilidad.tipoEmpresa
    );

    this.gobernabilidad.tipoPersonaText = this.tiposAsociado.find(
      (x) => x.value == this.gobernabilidad.tipoPersona
    ).text;
    this.gobernabilidad.tipoEmpresaText = tipoEmpresa ? tipoEmpresa.text : "";

    this.personasGobernabilidad = [
      ...this.personasGobernabilidad,
      this.gobernabilidad,
    ];
    this.gobernabilidad = new PersonaGobernabilidad();
    this.flagPersonaGobernabilidadNueva = false;
    actualizarCampos();
    this.alternarLoader();
  }

  verificarRoles(): boolean {
    let rolesValidos = true;
    this.configuracionGobernabilidad.forEach((element) => {
      let cantidad = element.codigo_cantidad;
      let tipoAsociado = element.codigo_tipo_asociado;
      if (cantidad > 0) {
        let result = this.personasGobernabilidad.filter(
          (x) => x.tipoPersona === tipoAsociado
        );
        if (result.length < cantidad) {
          mostrarToast(
            `Se requiere(n) ${cantidad} asociado(s) ${
              this.tiposAsociado.find((x) => x.value == tipoAsociado).text
            }.`
          );
          rolesValidos = false;
        }
      }
    });
    return rolesValidos;
  }

  async guardarGobernabilidad() {
    this.alternarLoader();
    this.gobernabilidad = new PersonaGobernabilidad();
    if (!this.validarPorcentajesGobernabilidad()) {
      this.alternarLoader();
      return;
    }

    if (this.plantillaPersonaNueva.IdPersona != 0) {
      let gobernabilidadExitosa: boolean = true;
      let verificarRoles = true;
      if (
        !this.personasGobernabilidad.reduce(
          (acum, x) => acum || x.exclusion,
          false
        )
      )
        verificarRoles = this.verificarRoles();
      if (verificarRoles) {
        this.personasGobernabilidad.forEach(async (x) => {
          let result = await this.polizaService.guardarGobernabilidad(
            x,
            this.plantillaPersonaNueva.IdPersona,
            this.emision.codigoUsuarioSISE
          );
          if (!result) {
            gobernabilidadExitosa = false;
            this.cancelarModalGobernabilidad();
          }
          mostrarToast(
            `El proceso de gobernabilidad ${
              gobernabilidadExitosa ? "" : "no "
            }ha sido exitoso.`
          );
        });
        if (gobernabilidadExitosa) {
          this.gobernabilidad.restablecerGobernabilidad();
          this.flagGobernabilidad = false;
          this.personaGobernabilidad = null;
          cerrarModal("modalGobernabilidad");
        }
      }
    }
    this.alternarLoader();
  }

  eliminarPersonaGobernabilidad(idPersona: number) {
    ocultarTooltips();
    this.personasGobernabilidad.splice(
      this.personasGobernabilidad.findIndex((x) => x.idPersona == idPersona),
      1
    );
  }

  editarPersonaGobernabilidad(
    idPersona: number,
    finalizarEdicion: boolean,
    cancelarEdicion: boolean = false
  ) {
    ocultarTooltips();
    this.personasGobernabilidad.forEach((x) => {
      if (x.idPersona == idPersona) {
        if (!finalizarEdicion) {
          x.editable = true;
          this.asociadoAEditar = Object.create(x);
        } else {
          x.editable = false;
          if (!cancelarEdicion) {
            let sumaPorcentajes = [
              this.gobernabilidad.porcentajeParticipacion,
              ...this.personasGobernabilidad.map((y) =>
                parseInt(
                  y.idPersona == idPersona
                    ? this.asociadoAEditar.porcentajeParticipacion + ""
                    : y.porcentajeParticipacion + ""
                )
              ),
            ].reduce((a, b) => a + b);
            if (sumaPorcentajes > 100) {
              mostrarToast(
                "El porcentaje o la suma de pocentajes no debe ser mayor a 100."
              );
              this.asociadoAEditar.porcentajeParticipacion =
                x.porcentajeParticipacion;
              x.editable = true;
              return;
            }
            x.tipoPersona = this.asociadoAEditar.tipoPersona;
            x.tipoPersonaText = this.tiposAsociado.find(
              (y) => y.value == x.tipoPersona
            ).text;
            x.tipoEmpresa = this.asociadoAEditar.tipoEmpresa;
            x.tipoEmpresaText = this.tiposEmpresa.find(
              (y) => y.value == x.tipoEmpresa
            ).text;
            x.exclusion = this.asociadoAEditar.exclusion;
            x.porcentajeParticipacion =
              this.asociadoAEditar.porcentajeParticipacion;
          }
          this.asociadoAEditar = null;
        }
      } else x.editable = false;
    });
    actualizarCampos();
  }

  validarPorcentajesGobernabilidad(): boolean {
    let sumaPorcentajes = [
      this.gobernabilidad.porcentajeParticipacion,
      ...this.personasGobernabilidad.map((x) => x.porcentajeParticipacion),
    ].reduce((a, b) => a + b);
    if (sumaPorcentajes > 100) {
      mostrarToast(
        "El porcentaje o la suma de pocentajes no debe ser mayor a 100."
      );
      return false;
    }
    return true;
  }

  cancelarModalGobernabilidad() {
    if (this.plantillaPersonaNueva.IdPersona == this.emision.tomador.idPersona)
      this.restablecerTomador();
    else if (
      this.plantillaPersonaNueva.IdPersona == this.emision.asegurado.idPersona
    )
      this.restablecerAsegurado();

    if (this.emision.tipoCliente == 4) {
      //Consorcio con Nit
      this.emision.participantes = [];
      this.cerrarModalConsorcioConNit();
    }
    this.flagGobernabilidad = false;
    this.flagPersonaGobernabilidadNueva = false;
    actualizarCampos();
    cerrarModal("modalGobernabilidad");
  }

  obtenerFecha(modelo, propiedad, nombreCampo) {
    modelo[propiedad] = obtenerFecha(nombreCampo);
  }

  validarAlfanumerico(modelo, propiedad) {
    modelo[propiedad] = validarAlfanumerico(modelo[propiedad]);
  }

  renderizarFechasExpedicion(plantilla, campoFechaExpedicion) {
    if (this.FechaExpTomadorFieldActivate) {
      if (![3, 7, 19].includes(plantilla.tipoDocumento)) {
        setTimeout(() => {
          let year = new Date().getFullYear();
          renderizarDatePickers(campoFechaExpedicion);
          actualizarRangoFechas(campoFechaExpedicion, [year - 100, year]);
        }, 1000);
      }
    } else {
      campoFechaExpedicion = new Date(
        new Date().getTime() - 24 * 60 * 60 * 1000
      );
    }
  }

  async cargarEmpresas() {
    let empresasResult = await this.polizaService.obtenerTiposEmpresa(
      this.gobernabilidad.tipoPersona
    );
    this.tiposEmpresa = [
      ...empresasResult.map((element) => {
        return { value: element.codigo_empresa, text: element.empresa };
      }),
    ];
  }

  validaTipoEmpresa() {
    cerrarToasts();
    this.gobernabilidad.tipoEmpresa = null;
    mostrarToast(
      "No se encuentra parametrizada la exclusión no se puede seleccionar tipo empresa"
    );
  }

  crearPersonaRisk(
    personaNueva: PersonaNueva,
    tipoPersona: number
  ): RiskRequest | null {
    if (
      !personaNueva ||
      personaNueva.CodigoTipoDocumento == null ||
      personaNueva.NumeroDocumento == null ||
      personaNueva.PrimerApellido == null ||
      personaNueva.PrimerNombre == null ||
      personaNueva.SegundoApellido == null ||
      environment.APIRiskIdAplication == null ||
      environment.APIRiskSucursal == null ||
      environment.APIRiskIdMovimiento == null ||
      environment.APIRiskModoValidacion == null
    ) {
      return null; // Devuelve null si alguna propiedad necesaria es null o undefined
    }

    return new RiskRequest(
      personaNueva.CodigoTipoDocumento,
      personaNueva.NumeroDocumento,
      personaNueva.PrimerApellido,
      personaNueva.SegundoApellido,
      personaNueva.PrimerNombre,
      personaNueva.SegundoNombre,
      environment.APIRiskIdAplication,
      "",
      "",
      tipoPersona,
      environment.APIRiskSucursal,
      environment.APIRiskIdMovimiento,
      environment.APIRiskModoValidacion
    );
  }
}
